import { ContentFlightStatus } from './contentflightstatus.model';
import { ContentCheckIn } from './contentcheckin.model';
import { ContentMyTrip } from './contentmytrip.model';

export class ContentMainNavigation {
  id: any;
  mainNavTitle: any;
  details: any;

  constructor(detailsof: any, contentjson?: any) {
    if (contentjson) {
      this.id = contentjson['id'];
      this.mainNavTitle = contentjson['mainNavTitle'];
      this.details = this.fillDetails(detailsof, contentjson['details']);
    } else {
      if (detailsof === 'my_trips') {
        this.id = 'my_trips';
        this.mainNavTitle = 'My Trips';
        this.details = this.fillDetails(detailsof);
      }
      if (detailsof === 'check_in') {
        this.id = 'check_in';
        this.mainNavTitle = 'Check-In';
        this.details = this.fillDetails(detailsof);
      }
      if (detailsof === 'flightstatus') {
        this.id = 'flightstatus';
        this.mainNavTitle = 'Flight Status';
        this.details = this.fillDetails(detailsof);
      }
    }
  }

  private fillDetails(detailsof: any, contentjson?: any): any {
    let details: any;
    if (detailsof === 'my_trips') {
      if (contentjson) {
        details = new ContentMyTrip(contentjson);
      } else {
        details = new ContentMyTrip();
      }
    }
    if (detailsof === 'check_in') {
      if (contentjson) {
        details = new ContentCheckIn(contentjson);
      } else {
        details = new ContentCheckIn();
      }
    }
    if (detailsof === 'flightstatus') {
      if (contentjson) {
        details = new ContentFlightStatus(contentjson);
      } else {
        details = new ContentFlightStatus();
      }
    }
    return details;
  }
}
